import useId from 'modules/reports/hooks/id'
import usePrefix from 'modules/reports/hooks/prefix'
import React, {useState} from 'react'
import ReportsDockContext, {ReportsDockContextProps} from './ReportsDock.context'
import useStyles from './ReportsDock.styles'

export type ReportsDockExtensionProps = {}

type Props = ReportsDockExtensionProps & {
  children: React.ReactNode
  'data-testid': string
}

function ReportsDock(props: Props) {
  const [extended, setExtended] = useState(false)

  const {children} = props
  const classes = useStyles()
  const p = usePrefix(props['data-testid'])
  const id = useId()

  const contextValue: ReportsDockContextProps = {id, prefix: p(), extended, setExtended}

  return (
    <div className={classes.root} data-testid={p()}>
      <ReportsDockContext.Provider value={contextValue}>{children}</ReportsDockContext.Provider>
    </div>
  )
}

export default ReportsDock
